const wrapper = document.querySelectorAll(".inline-video__wrapper");
//const videoInfoButtons = document.querySelectorAll( ".inline-video__info-buttons");
const videoDescBox = document.querySelectorAll(".video-box");
const descriptionBox = document.querySelectorAll(".inline-video__description");
const helper = window.squiz.fn;

wrapper.forEach((component, i) => {
    const videoBox = component.querySelectorAll(".video-box"),
        videoInfoButtons = component.querySelectorAll(".inline-video__info-buttons");

    if (videoBox.length > 1 && i === videoBox.length - 1) {
        videoBox[i].classList.add("hidden");
    } else {
        const buttons = component.querySelector(".inline-video__info-buttons");

        if (buttons) {
            component.querySelector(".inline-video__info-buttons").classList.add("active");
        }
    }

    videoInfoButtons.forEach((button, index) => {
        button.addEventListener("click", function () {
            const parent = helper.parentsUntil(this, "inline-video__wrapper"),
                videoBoxes = parent.querySelectorAll(".video-box");

            if (parent.querySelectorAll(".video-box").length > 1) {
                videoBoxes.forEach(box => box.classList.add("hidden"));

                videoBoxes[index].classList.remove("hidden");

                parent.querySelectorAll(".inline-video__info-buttons").forEach((btn) => btn.classList.remove("active"));

                this.classList.add("active");
            }
        });
    });
});

descriptionBox.forEach(box => {
    if (!box.children.length) {
        const navigation = helper.parentsUntil(box, "inline-video__wrapper").querySelector(".inline-video__info");

        navigation.classList.add("inline-video__info--no-tabs");
        
        box.remove();
    }
});

//videoInfoButtons.forEach((button, index) => {
    //button.addEventListener("click", function () {
        //const parent = helper.parentsUntil(this, "inline-video__wrapper"),
            //videoBoxes = parent.querySelectorAll(".video-box");

        //if (parent.querySelectorAll(".video-box").length > 1) {
            //videoBoxes.forEach(box => box.classList.add("hidden"));

            //videoBoxes[index].classList.remove("hidden");

            //parent.querySelectorAll(".inline-video__info-buttons").forEach((btn) => btn.classList.remove("active"));

            //this.classList.add("active");
        //}
    //});
//});
